import React from 'react';
import { Form, Input, Button, Card, Space } from 'antd';
import { createContextLogger } from '../../utils/logger';

const logger = createContextLogger('MetadataEditor');
import { useTranslation } from 'react-i18next';

// Type definitions
interface MetadataEditorProps {
  type?: string;
  itemId?: string;
}

interface FormValues {
  name: string;
  host?: string;
  port?: number;
  database?: string;
  username?: string;
  password?: string;
  baseUrl?: string;
  authType?: string;
}

const MetadataEditor: React.FC<MetadataEditorProps> = ({ type, itemId }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<FormValues>();

  const handleSave = async (values: FormValues): Promise<void> => {
    logger.debug('Saving metadata:', values);
    // TODO: Implement save functionality
  };

  return (
    <Card title={`${type} ${t('metadataEditor.editor')}`}>
      <Form form={form} layout="vertical" onFinish={handleSave}>
        <Form.Item
          name="name"
          label={t('metadataEditor.name')}
          rules={[{ required: true, message: t('metadataEditor.nameRequired') }]}
        >
          <Input />
        </Form.Item>

        {/* Database connection fields */}
        {type === 'database' && (
          <>
            <Form.Item
              name="host"
              label={t('metadataEditor.host')}
              rules={[{ required: true, message: t('metadataEditor.hostRequired') }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="port"
              label={t('metadataEditor.port')}
              rules={[{ required: true, message: t('metadataEditor.portRequired') }]}
            >
              <Input type="number" />
            </Form.Item>
            <Form.Item
              name="database"
              label={t('metadataEditor.database')}
              rules={[{ required: true, message: t('metadataEditor.databaseRequired') }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="username"
              label={t('metadataEditor.username')}
              rules={[{ required: true, message: t('metadataEditor.usernameRequired') }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="password"
              label={t('metadataEditor.password')}
              rules={[{ required: true, message: t('metadataEditor.passwordRequired') }]}
            >
              <Input.Password />
            </Form.Item>
          </>
        )}

        {/* REST API connection fields */}
        {type === 'rest' && (
          <>
            <Form.Item
              name="baseUrl"
              label={t('metadataEditor.baseUrl')}
              rules={[{ required: true, message: t('metadataEditor.baseUrlRequired') }]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="authType" label={t('metadataEditor.authType')}>
              <Input />
            </Form.Item>
          </>
        )}

        <Space>
          <Button type="primary" htmlType="submit">
            {t('common.save')}
          </Button>
          {itemId && <Button danger>{t('common.delete')}</Button>}
        </Space>
      </Form>
    </Card>
  );
};

export default MetadataEditor;
